<div class="row signupRow">
    <span class="imgCont"><img src="assets/logo-dark.png" class="imgPosit"></span><br/>
    <mat-card class="signup-card">
        <mat-card-title class="signupTitle">Create account</mat-card-title>
        <mat-card-subtitle class="loginSubtitle">Already have an account? <a  class="customlink" (click)="routeTologin()">Click here to login</a></mat-card-subtitle>
        <mat-card-content class="mt-20">
            <h5 class="customfont1">Name</h5>
            <div class="p-field mb-20">
                <input type="username" class="inputfiled" placeholder="Name" pInputText />
            </div>
            <h5 class="customfont1">Email</h5>
            <div class="p-field mb-20">
                <input type="email" class="inputfiled" placeholder="Email" pInputText />
            </div>
            <h5 class="customfont1">Password</h5>
            <p-password placeholder="Password" [toggleMask]="true">
                <ng-template pTemplate="footer">
                    <p-divider></p-divider>
                    <p class="p-mt-2">Suggestions</p>
                    <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
                        <li>At least one lowercase</li>
                        <li>At least one uppercase</li>
                        <li>At least one numeric</li>
                        <li>Minimum 8 characters</li>
                    </ul>
                </ng-template>
            </p-password>
            <h5 class="customfont1 mt-20">Confirm password</h5>
            <p-password placeholder="Password" [toggleMask]="true"></p-password>
            <h5 class="customfont1 mt-20">Account type</h5>
            <p-selectButton [options]="stateOptions" class="selectCustom" optionLabel="label" optionValue="value"></p-selectButton>
        </mat-card-content>
        <mat-card-subtitle class="loginSubtitle"><div class="p-field-checkbox"><p-checkbox inputId="binary"></p-checkbox>  I accept the <a href="#" class="customlink">service terms</a></div></mat-card-subtitle>
        <mat-card-actions>
            <button pButton pRipple type="button" label="Register" class="p-button-raised signupbutton"></button>
        </mat-card-actions>
    </mat-card>
</div>
